import React from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';

import { ModalSto } from 'components/sto';

const MFAResentModal = (props) => {
    const { formatMessage } = useIntl();
    return (
        <ModalSto
            buttonSize="large"
            isCTA={false}
            modalType="resendCode"
            okText="general.ok"
            onOk={props.onOk}
            visible={props.visible}
            wrapClassName="otp-resent-modal"
        >
            <React.Fragment>
                {props.otpSent ? (
                    <React.Fragment>
                        <h3 className="resend-popup">
                            <FormattedMessage id="pages.MFA.resendCode" />
                        </h3>
                        <p>
                            <FormattedMessage id="pages.OTP.resendCode.message.first.line" />
                        </p>
                        <p>
                            <FormattedMessage id="pages.OTP.resendCode.message.second.line" />
                        </p>
                        <p>
                            <FormattedMessage id="pages.OTP.resendCode.message.third.line" />
                            <a
                                className="mfa-resend-modal-contact-link"
                                href={formatMessage({ id: 'mfa.resend.code.contact.link' })}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <FormattedMessage id="mfa.resend.code.contact.link" />
                            </a>
                        </p>
                    </React.Fragment>
                ) : (
                    <p>
                        <FormattedMessage id="pages.OTP.resendFailure" />
                    </p>
                )}
            </React.Fragment>
        </ModalSto>
    );
};

export default injectIntl(MFAResentModal);
